import { render, staticRenderFns } from "./OneOrMoreReservations.vue?vue&type=template&id=1ddc1dd3&scoped=true&"
import script from "./OneOrMoreReservations.vue?vue&type=script&lang=js&"
export * from "./OneOrMoreReservations.vue?vue&type=script&lang=js&"
import style0 from "./OneOrMoreReservations.vue?vue&type=style&index=0&id=1ddc1dd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ddc1dd3",
  null
  
)

export default component.exports